const saveDiscardChangesModal = {
  methods: {
    async checkForChangesAndNavigate(next) {
      if (this.hasChanged()) {
        const confirmed = await this.$refs.saveDiscardChangesModal.confirm();
        if (confirmed === 'save') {
          const isValid = await this.validate();
          if (isValid) {
            next();
          } else {
            next(false);
          }
        } else if (confirmed === 'discard') {
          next();
        } else if (confirmed === 'cancel') {
          next(false);
        }
      } else {
        next();
      }
    },
  },
};
export default saveDiscardChangesModal;
